import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ckxh7e6dy: FaireProductEntity = {
  token: "p_7ckxh7e6dy",
  type: "product",
  name: '72" Hanging Halloween Animated Shaking Ghost on Swing',
  brandToken: "b_azgyao0cia",
  brandName: "WORTH IMPORTS",
  imageUrl:
    "https://cdn.faire.com/fastly/e655b0a3fd541be37e641710657f8b769d49441aba743a1aec16071601e922c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bba33612e7d6bd8827367474b278423ffc302d18c4f9ec7ed6b8a9b52ec45326.jpeg",
    "https://cdn.faire.com/fastly/46996572e7755a3718f0fb31301f98491d85625466627ee091cef6d9a35ff712.jpeg",
  ],
  priceDollars: 26.82,
  description:
    "Create a spine-chilling scene with the 72\" Lifesize Hanging Halloween Animated Shaking Ghost on Swing. This eerie ghost shakes while making spooky sounds and laughter, adding motion and sound to your Halloween display. With wired arms you can pose as you like, it's the perfect piece for a truly haunting setup.\n",
  tags: [],
  msrpDollars: 64.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:43.222Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
